import { FileProviderViewState } from 'owa-fileprovider-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import showFilePickerErrorMessage from '../actions/errorMessageActions/showFilePickerErrorMessage';
import getDefaultFileProvider from '../actions/helpers/getDefaultFileProvider';
import { getFilePickerStore } from '../store/filePickerStore';
import FilePickerErrorMessageType from '../types/FilePickerErrorMessageType';
import { shouldHideOneDrive } from './getAddedProviders';

export async function initializeFilePickerViewState(providers: FileProviderViewState[]) {
    const viewState = getFilePickerStore().viewState;
    if (!providers || providers.length === 0) {
        showFilePickerErrorMessage(
            getUserConfiguration().SessionSettings.IsShadowMailbox
                ? FilePickerErrorMessageType.NoGDriveProvider
                : FilePickerErrorMessageType.NoOneDriveProvider,
            viewState.filePickerErrorMessageViewState
        );
        return;
    }

    const defaultProvider = getDefaultFileProvider(filterForGroupsOnlyOneDriveProvider(providers));
    changeSelectedFileProvider(defaultProvider, viewState);
}

function filterForGroupsOnlyOneDriveProvider(
    providers: FileProviderViewState[]
): FileProviderViewState[] {
    if (!shouldHideOneDrive()) {
        return providers;
    }
    return providers.filter(provider => !!provider.name);
}
